import { render, staticRenderFns } from "./FieldReview.vue?vue&type=template&id=c5a71334"
import script from "./FieldReview.vue?vue&type=script&lang=js"
export * from "./FieldReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports